type MessageSection = 'ENQUIRY' | 'NEWSLETTER';

export const getScopedMessageKey = (section: MessageSection, statusKey: string) =>
  `${section}.${statusKey}`;
